import * as React from 'react';

import styles from './styles.module.scss';

export interface FieldItem {
	id: string;
	name: string;
}

interface OwnProps {
	field: FieldItem;
	isFocused: boolean;
	isHighlighted: boolean;
	onFocus: (id: string) => void;
}

type Props = OwnProps;

const BillableWorkField: React.FC<Props> = (props) => {
	const { field, isHighlighted, isFocused, onFocus } = props;

	const { id, name } = field;

	const handleFocus = React.useCallback(() => {
		onFocus(id);
	}, [id, onFocus]);

	const className = `${styles.BillableWorkField} ${isHighlighted ? styles.highlighted : ''} ${isFocused ? styles.focused : ''}`;

	return (
		<div className={className} onClick={handleFocus}>
			<div className={`${styles.findIcon} icon-search`} />
			<div>{name}</div>
		</div>
	);
};

export default React.memo(BillableWorkField);
